"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function escapeUri(uri) {
    var output = encodeURIComponent(uri);
    // AWS percent-encodes some extra non-standard characters in a URI
    output = output.replace(/[!'()*]/g, hexEncode);
    return output;
}
exports.escapeUri = escapeUri;
function hexEncode(c) {
    return "%" + c
        .charCodeAt(0)
        .toString(16)
        .toUpperCase();
}
//# sourceMappingURL=escape-uri.js.map